import React, { useState, useCallback } from 'react';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@mui/styles';
import {
    Button,
    IconButton,
    Snackbar,
    Typography,
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import './react-dropzone.css';
import {isImage} from './helpers.js';

const styles = theme => ({
  dropItem: {
    borderColor: theme.palette.divider,
    background: theme.palette.background.default,
    borderRadius: 8,
    color: theme.palette.text.disabled,
    textAlign: 'center'
  },
  uploadIconSize: {
    display: 'inline-block',
    '& svg': {
      width: 50,
      height: 50,
      fill: theme.palette.primary.main,
    }
  },
  button: {
    marginTop: 20
  }
});

function MaterialDropZone(props) {
  const [openSnackBar, setOpenSnackbar] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const {
    files,
    classes,
    showPreviews,
    maxSize,
    text,
    showButton,
    filesLimit,
    handleUpload,
    ...rest
  } = props;

  const onDrop = useCallback((filesVal) => {
    let oldFiles = files;
    const filesLimitVal = filesLimit || '3';
    oldFiles = oldFiles.concat(filesVal);
    if (oldFiles.length > filesLimit) {
      setOpenSnackbar(true);
      setErrorMessage(`Cannot upload more than ${filesLimitVal} items.`);
    } else {
      handleUpload(oldFiles);
    }
  }, [files, filesLimit]);

  const onDropRejected = () => {
    setOpenSnackbar(true);
    setErrorMessage('File too big, max size is 12MB');
  };

  const handleRequestCloseSnackBar = () => {
    setOpenSnackbar(false);
  };

  const handleRemove = useCallback((file, fileIndex) => {
    // This is to prevent memory leaks.
    window.URL.revokeObjectURL(file.preview);
    // handleUpload(null);
    handleUpload(files => {
      const tempFiles = [...files];
      tempFiles.splice(fileIndex, 1);
      return tempFiles;
    });
  }, [files]);

  const fileSizeLimit = maxSize || 3000000;
  const DeleteBtn = ({ file, index}) => (
    <div className="middle">
      <IconButton onClick={() => handleRemove(file, index)}>
        <DeleteIcon className="removeBtn" />
      </IconButton>
    </div>
  );

  DeleteBtn.propTypes = {
    file: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired
  };

  // const Previews = ({ file }) => {
  //   return (
  //     <div>
  //         <Typography color="primary">{file.name}</Typography>
  //         <div className="imageContainer col InsertDriveFileIconImg">
  //           <InsertDriveFileIcon className="smallPreviewImg" alt="preview" />
  //           <DeleteBtn file={file} />
  //         </div>
  //     </div>
  //   );
  // };
  const Previews = ({ filesArray }) => filesArray.map((file, index) => {
    const base64Img = URL.createObjectURL(file);
    if (isImage(file)) {
      return (
        <div key={index.toString()}>
          <div className="imageContainer col fileIconImg">
            <figure className="imgWrap"><img className="smallPreviewImg" src={base64Img} alt="preview" /></figure>
            <DeleteBtn file={file} index={index} />
          </div>
        </div>
      );
    }
    return (
      <div key={index.toString()}>
        <Typography color="primary">{file.name}</Typography>
        <div className="imageContainer col fileIconImg">
          <InsertDriveFileIcon className="smallPreviewImg" alt="preview" />
          <DeleteBtn file={file} index={index} />
        </div>
      </div>
    );
  });

  Previews.propTypes = {
    filesArray: PropTypes.array.isRequired
  };

  let dropzoneRef;
  return (
    <div>
      <Dropzone
        accept={props.accept}
        onDrop={onDrop}
        onDropRejected={onDropRejected}
        acceptClassName="stripes"
        rejectClassName="rejectStripes"
        maxSize={fileSizeLimit}
        ref={(node) => { dropzoneRef = node; }}
        {...rest}
      >
        {({ getRootProps, getInputProps }) => (
          <div {...getRootProps()} className={classNames(classes.dropItem, 'dropZone')}>
            <div className="dropzoneTextStyle">
              <input {...getInputProps()} />
              <Typography color="primary"><b>{text}</b></Typography>
              <div className={classes.uploadIconSize}>
                <CloudUploadIcon fontSize='small' />
              </div>
            </div>
          </div>
        )}
        {/* end */}
      </Dropzone>
      <div className="row preview">
        {(files && files.length > 0) && <Previews filesArray={files} />}
      </div>
      <Snackbar
        open={openSnackBar}
        message={errorMessage}
        autoHideDuration={4000}
        onClose={handleRequestCloseSnackBar}
      />
    </div>
  );
}

MaterialDropZone.propTypes = {
  files: PropTypes.array.isRequired,
  text: PropTypes.string.isRequired,
  acceptedFiles: PropTypes.array,
  showPreviews: PropTypes.bool.isRequired,
  showButton: PropTypes.bool,
  maxSize: PropTypes.number.isRequired,
  filesLimit: PropTypes.number.isRequired,
  classes: PropTypes.object.isRequired,
};

MaterialDropZone.defaultProps = {
  acceptedFiles: [],
  showButton: false,
};

export default withStyles(styles)(MaterialDropZone);
